import { REVIEWS_FORM_HASH } from 'common/constants';

export const getOtzyvyUrl = (isMoscow: boolean, reviewsCount?: number | null): string => {
  if (isMoscow) {
    return reviewsCount ? 'otzyvy/' : REVIEWS_FORM_HASH;
  }

  return '#reviews';
};
